<template>
<v-card flat style="padding:5px;border:1px solid #ddd;border-radius:10px;margin-bottom:8px;">
  <v-card-title style="padding:0px;"
    @click="$router.push({name: 'UserTop', params: {id: c.user.uid}})"
  >
    <v-avatar size="25"><v-img :src="c.user.imageurl" :lazy-src="require('@/assets/img/person_icon.png')"/></v-avatar>
    {{c.user.displayName}}
    <v-spacer></v-spacer>
    <span style="font-size:90%;color:#666;">{{c.timestamp | displayDate}}</span>
  </v-card-title>
  <v-card-text xs12 style="text-align:left;padding:7px 0px 0px 0px;" v-html="$options.filters.changeBR(c.content)">
  </v-card-text>
</v-card>
</template>

<script>
export default {
  name: 'ReviewCommentCard',
  data () {
    return {
    }
  },
  props: {
    c: Object
  },
  filters: {
    displayDate (value) {
      let date = new Date()
      let now = date.getTime()
      date.setTime(value.seconds * 1000)
      let diff = (now - value.seconds * 1000) / (60 * 1000) // 分
      if (diff < 60) {
        return `${Math.floor(diff)}分前`
      } else if (diff < 24 * 60) {
        return `${Math.floor(diff / 60)}時間前`
      } else {
        return `${date.getMonth() + 1}月${date.getDate()}日`
      }
    },
    changeBR (v) {
      return v.replace(/\r?\n/g, '<br>')
    }
  },
  methods: {
  },
  components: {
  }
}
</script>

<style scoped>
</style>